import { ModelRow } from "@mcleod/core";
import {
    DataSourceMode, Label, LookupModelSelectionEvent, TableRow, TableRowCreationEvent, TableRowDisplayEvent,
    TableRowMode, Textbox, ValidationResult 
} from "@mcleod/components";
import {
    AutogenLayoutMobileCommFilterJunctionDriverTable
} from "./autogen/AutogenLayoutMobileCommFilterJunctionDriverTable";

export class MobileCommFilterJunctionDriverTable extends AutogenLayoutMobileCommFilterJunctionDriverTable {
    tableMCFilterJunctionDriverOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = event.getTableRow().data as ModelRow;

        if (tableRow.mode === TableRowMode.QUICK_ADD) {
            const labelType = tableRow.findComponentById("labelType") as Label;
            labelType.marginTop = 12;
        }
    }

    async textboxDriverOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const selectedRow = event.selection;
        if (selectedRow) {
            const tableRow = TableRow.getContainingTableRow(event.target);
            const textboxDriver: Textbox = tableRow.findComponentById("textboxDriver") as Textbox;

            textboxDriver.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                if (mode === DataSourceMode.SEARCH) {
                    return null;
                }
                const result: ValidationResult = {
                    component: textboxDriver,
                    isValid: true
                }

                let idExists = false;
                this.tableMCFilterJunctionDriver.rows.forEach(row =>  {
                    if (event.selection.get("id") === row.data.get("mc_object_id")) {
                        idExists = true;
                        result.isValid = false;
                        result.validationMessage = "Row already exists for this driver";
                        return;
                    }
                });
                return result;
            };

            const labelType: Label = tableRow.findComponentById("labelType") as Label;
            labelType.text = event.selection.get("type_of");

            if (labelType.text === 'O') {
                labelType.text = "Owner";
            } else if (labelType.text === 'C') {
                labelType.text = "Company";
            }
        }
    }

    tableMCFilterJunctionDriverOnRowCreate(event: TableRowCreationEvent) {
        const tableRow = event.getTableRow();
        const modelRow = event.getTableRow().data as ModelRow;
        const lmData = modelRow.getLookupModelData("mc_object_id");

        if (lmData) {
            modelRow.set("driver.type_of", lmData[0].get("type_of"));
        }
    }
}
